import { Rv, Counter, Kicker, Source } from "../ui";
import { Bars3D } from "../Bars3D";
import { Ring3D } from "../Ring3D";

export const S1 = () => (
  <div className="slide s-cover" data-testid="slide-1">
    <div className="cover-text">
      <Rv d={0.2}><div className="kicker">Storia dell'economia e dell'impresa · Caso di studio</div></Rv>
      <Rv d={0.45}><h1 className="display">ENI e la<br />sostituzione<br /><em>del gas russo</em></h1></Rv>
      <Rv d={0.85}><p className="lede">Dalla concentrazione alla diversificazione. Italia, 2021 — 2024.</p></Rv>
      <Rv d={1.25}>
        <div className="keys" data-testid="cover-keys">
          <span><kbd>→</kbd> avanti</span><span><kbd>F</kbd> schermo intero</span><span><kbd>G</kbd> indice</span>
        </div>
      </Rv>
    </div>
    <Rv d={1.5} className="legend">
      <span><i style={{ background: "#ffb347" }} />Gasdotti</span>
      <span><i style={{ background: "#6cc5ff" }} />GNL</span>
      <span><i style={{ background: "#ff5a1f" }} />Russia</span>
    </Rv>
  </div>
);

export const S2 = () => (
  <div className="slide split" data-testid="slide-2">
    <div className="col">
      <Kicker n="01">Il punto di partenza</Kicker>
      <Rv d={0.3}><h2 className="title">Nel 2021 la Russia era il <em>pilastro</em> del gas italiano.</h2></Rv>
      <Rv d={0.6} className="giant-block">
        <div className="giant amber"><Counter to={29.2} delay={700} dur={2400} testid="s2-counter" /><span className="unit">mld m³</span></div>
        <div className="cap">importati dalla Russia nel 2021</div>
      </Rv>
      <Rv d={1.5}><blockquote className="quote">La crisi del 2022 non riguardava solo i prezzi: metteva in discussione l'intera struttura delle forniture.</blockquote></Rv>
    </div>
    <Rv d={0.5} className="col chart-col">
      <Ring3D pct={0.4} testid="s2-ring">
        <div className="ring-num">≈40<span>%</span></div>
        <div className="cap">delle importazioni di gas</div>
      </Ring3D>
    </Rv>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · dati MASE</Source>
  </div>
);

const CRASH = [
  { label: "2021", value: 29.2, color: "#ffb347" },
  { label: "2023", value: 2.9, from: 29.2, at: 1700, color: "#ff4a1c" },
  { label: "2024", value: 5.7, from: 29.2, at: 2700, color: "#ff7a2e" },
];

export const S3 = () => (
  <div className="slide split wide-right" data-testid="slide-3">
    <div className="col">
      <Kicker n="02">Il crollo</Kicker>
      <Rv d={0.3}><h2 className="title">Dopo l'invasione dell'Ucraina, un <em>crollo</em> e una ripresa solo parziale.</h2></Rv>
      <Rv d={3.4} className="delta-block">
        <div className="delta" data-testid="s3-delta">−90%</div>
        <div className="cap">volumi russi 2021 → 2023</div>
      </Rv>
      <Rv d={3.9}><p className="body">Nel 2024 i flussi risalgono a 5,7 mld m³: una ripresa che resta ancora lontana dai livelli prebellici.</p></Rv>
    </div>
    <Rv d={0.4} className="col chart-col">
      <Bars3D data={CRASH} max={30} height={3.9} spacing={2.1} width={1.05} testid="s3-bars" cam={[0, 2.4, 11]} />
      <div className="drag-hint">Importazioni dalla Russia · mld m³ · trascina per ruotare</div>
    </Rv>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · dati MASE · variazione calcolata sui dati riportati</Source>
  </div>
);

export const S4 = () => (
  <div className="slide split globe-right" data-testid="slide-4">
    <div className="col">
      <Kicker n="03">Le basi della risposta</Kicker>
      <Rv d={0.3}><h2 className="title">ENI non partiva <em>da zero</em>.</h2></Rv>
      <Rv d={0.6}><p className="body">Una presenza storica in Africa e nel Mediterraneo: Algeria, Libia, Egitto, Congo e Mozambico erano già parte del portafoglio di ENI.</p></Rv>
      <div className="stat-row">
        <Rv d={1.0} className="stat glass">
          <div className="stat-num amber"><Counter to={50.88} dec={2} delay={1100} testid="s4-gas" /></div>
          <div className="stat-unit">mld m³</div>
          <div className="cap">gas naturale venduto · 2024</div>
        </Rv>
        <Rv d={1.3} className="stat glass">
          <div className="stat-num ice"><Counter to={9.8} delay={1400} testid="s4-lng" /></div>
          <div className="stat-unit">mld m³</div>
          <div className="cap">GNL venduto · 2024</div>
        </Rv>
      </div>
    </div>
    <Source>ENI S.p.A., Relazione Finanziaria Annuale 2024 · Global Gas & LNG Portfolio</Source>
  </div>
);
